import { atlasRoutes } from "@/app/router/routes";
import { LookupByUuidForm } from "@/components/forms/lookup-by-uuid-form";
import { FC } from "react";
import { useNavigate } from "react-router";

export const SpaceAccountAppCalloutsRootPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1>SpaceAccountAppCalloutsRootPage</h1>

      <LookupByUuidForm
        onSubmit={uuid =>
          navigate(
            atlasRoutes.spaceAccountAppCalloutsView({
              params: { spaceAccountAppCalloutId: uuid },
            }).path
          )
        }
      />
    </div>
  );
};
